import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'

import { auth } from '../firebase';
import { fb } from '../firebase/firebase';
import { Badge, Input, message, Button } from "antd";
import {
  Link,
} from 'react-router-dom'


class ChangePW extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      currentpw: '',
      newpw: '',
      confirmpw: '',
      invalidPage: false,
      disabled: false
    }

  }
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ email: user.email })
      }
    });
    this.setState({ currentpw: null })
  }

  lol = () => {
    if (this.state.currentpw.length > 5) {
      if (this.state.newpw == this.state.confirmpw) {
        if (this.state.newpw.length > 5) {
          if (this.state.newpw == this.state.currentpw) {
            message.error('You are using the same password as your current password.')
          } else {
            this.changeIt()
          }
        } else {
          message.error('New password must be at least 6 characters.')
        }
      }
      else {

        message.error('Your new password does not match your confirm password.')
      }
    } else {
      message.error('Please enter current password. Minimum 6 characters.')
    }
  }


  changeIt = () => {
    this.setState({ disabled: true })
    var unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        var credentials = fb.auth.EmailAuthProvider.credential(
          user.email,
          this.state.currentpw
        );
        var newPassword = this.state.newpw;
        // Prompt the user to re-provide their sign-in credentials
        var self = this
        user.reauthenticateWithCredential(credentials).then(function () {
          // User re-authenticated.
          user.updatePassword(newPassword).then(function () {
            // Update successful.
            message.info('Your password successfully updated!')
            unsubscribe()
            self.setState({ invalidPage: true })
            
          }).catch(function (error) {
            // An error happened.
            unsubscribe()
            message.error(error.message)
            self.setState({ disabled: false })
          })
        }).catch(function (error) {
          // An error happened.
          unsubscribe()
          message.error('Your current password is invalid.')
        });

      } else {
        unsubscribe()
        message.error('no user')
      }
    });

  }

  render() {
    return (
      <div>
        <h1>Change Password <Badge count={this.state.email} style={{ backgroundColor: '#52c41a' }} /></h1>
        
        <br></br>
        <div className='pw'>
          <Input.Password
            size="large"
            placeholder="Current Password"
            onInput={evt => this.setState({ currentpw: evt.target.value })}
            value={this.state.currentpw}
          />
        </div>
        <div className='pw'>
          <Input.Password
            size="large"
            placeholder="New Password"
            onInput={evt => this.setState({ newpw: evt.target.value })}
            value={this.state.newpw}
          />
        </div>
        <div className='pw'>
          <Input.Password
            size="large"
            placeholder="Confirm New Password"
            onInput={evt => this.setState({ confirmpw: evt.target.value })}
            value={this.state.confirmpw}
          />
        </div>
        <br></br>
        <Button type="primary" size="large" onClick={this.lol} disabled={this.state.disabled}>Change Password</Button>

        {this.state.invalidPage ?
          <Redirect to='/dashboard' />
          :
          <div />
        }

      </div>
    );

  }

}

export default ChangePW;



// WEBPACK FOOTER //
// ./src/views/changepw.js